// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React, { useCallback, useId } from 'react'
import classNames from 'classnames'
import { Tooltip } from 'ui_kit_qmd'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { getVisitsConfig } from '../VisitConstants'
import { visitDataItem } from './visitDataItem'
import { getTabId } from '../../../utils/common'
import { EMPTY_VALUE_TEXT, RESCHEDULE_VISIT_PAGE_PATH } from '../../../utils/constants'
import { getMediaFile } from '../../../store/file-pop-up/FilePopUpThunk'
import { getIDVerification } from '../../../store/id-verification-pop-up/IDVerificationPopUpThunk'
import { getVisitInfoPromise } from '../visitService'
import { useRescheduleLocationState } from '../../CalendarPage/DetailsView/hooks/useRescheduleLocationState'
// @ts-expect-error TS6192 -- MIGRATION: not approved, fix when encountered
import { getUserFriendlyErrorMessage, errorCodes } from '../../../utils/errormessages'
// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import { setVisitError } from '../../../store/visits/VisitsActions'

export const VisitsTableRow = ({
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  visit,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  visitId,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  visitsMode,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  setTriggerTabId,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  onClickRemarks,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  timeZone,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  setSelectedVisitId,
}) => {
  const currentTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const tabId = getTabId()
  const id = useId()

  const onClickBookingId = useCallback(
    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    (visitId) => {
      setTriggerTabId(tabId)
      setSelectedVisitId(visitId)
    },
    [setTriggerTabId, tabId],
  )
  const { getRescheduleLocationState } = useRescheduleLocationState()

  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const flags = useSelector((state) => state.flags.flags)

  const getFile = useCallback(() => {
    dispatch(getMediaFile(visit.Patient, tabId))
  }, [dispatch, visit.Patient, tabId])

  const getIDVerificationInfo = useCallback(() => {
    dispatch(getIDVerification(visit.Patient.PatientId, tabId))
  }, [dispatch, visit.Patient, tabId])

  const visitsConfig = getVisitsConfig(visitsMode)

  const redirectToRescheduleVisitPage = async () => {
    try {
      const combinedVisitDetailsInfo = await getVisitInfoPromise(visitId, dispatch)

      const navigationState = getRescheduleLocationState(combinedVisitDetailsInfo, timeZone ?? currentTimeZone)

      navigate(RESCHEDULE_VISIT_PAGE_PATH, {
        state: {
          ...navigationState,
          isVisits: true,
        },
      })
    } catch (error) {
      console.error('Failed to fetch necessary data for rescheduling:', error)
      // Optionally, display an error message to the user
    }
  }
  // Prepare the visit data using visitDataItem, passing redirectToRescheduleVisitPage
  const visitDataMapped = visitDataItem(
    {
      ...visit,
      visitId,
      visitsMode,
      onClickRemarks,
      timeZone,
      showIDTag: flags.id_verification_show_tag_admin && visit.Patient?.IdentityVerification?.Status,
      onClickBookingId,
      getIDVerificationInfo,
      getFile,
    },
    redirectToRescheduleVisitPage, // Pass the redirect function here
  )

  return (
    <>
      {visitsConfig.map(({ value, className, withTooltip, align = 'left' }, index) => {
        // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
        const { tooltip, sectionContent, afterContentIcon } = visitDataMapped[value] || {}

        return (
          <div
            key={value}
            className={classNames(
              { [`visits-table-row--align-${align}`]: value !== 'tags' }, // Apply alignment class only if it's not the 'tags' column
              // @ts-expect-error TS2464 -- MIGRATION: not approved, fix when encountered
              { [className]: className },
              { 'visits-table-row--no-padding': value === 'tags' }, // Apply no padding if the value is 'tags'
            )}>
            {withTooltip ?
              <>
                <Tooltip content={tooltip} targetId={`${id}-${index}`}>
                  <section id={`${id}-${index}`} className='visits-row-item'>
                    {sectionContent}
                  </section>
                </Tooltip>
                {afterContentIcon ?? null}
              </>
            : <>
                <section className='visits-row-item'>{sectionContent}</section>
                {afterContentIcon ?? null}
              </>
            }
            {value === 'tags' && !sectionContent && !afterContentIcon && EMPTY_VALUE_TEXT}
          </div>
        )
      })}
    </>
  )
}
